import * as React from "react";
import { type RouteProps } from "react-router";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Enterprise = React.lazy(() => import("./Enterprise"));

export default function EnterpriseIndex(): Array<React.ReactElement<RouteProps>> {
    return [
        <PermissionRoute
            permissions={[ "view_enterprise_connections" ]}
            title="Enterprise | Shopfront"
            path="/enterprise"
            key="enterprise"
            element={<Enterprise />}
        />,
    ];
}
